import { RiderHelper } from './RiderHelper';
import { VEHICLE_TYPES } from '../constants/constants';

export function buildQuickScheduleDraft({
  step1,
  step2,
  step3,
  step4,
  user,
  existingDraft,
  driverNotesLegA = '',
  driverNotesLegB = '',
  driverNotes = '',
  isRoundTrip = false,
}) {
  const defaultOrgId =
    user?.organizationId ||
    user?.organization?.id ||
    user?.permissions?.orgList?.[0]?.id ||
    null;

  const normalizedStep1 = {
    ...(step1 || {}),
    organizationId: step1?.organizationId || defaultOrgId,
    riderInfo: {
      ...(step1?.riderInfo || {}),
    },
  };

  const riderInfo = normalizedStep1.riderInfo || {};
  if (!normalizedStep1.formattedRiderName && (riderInfo.firstName || riderInfo.lastName)) {
    normalizedStep1.formattedRiderName = RiderHelper.getRiderAutoCompleteName(riderInfo);
  }

  let normalizedStep4 = { ...(step4 || {}) };

  if (isRoundTrip) {
    normalizedStep4 = {
      ...normalizedStep4,
      driverNotesLegA,
      driverNotesLegB,
      rideNotes: '',
    };
  } else if (step2?.vehicleType === VEHICLE_TYPES.UBER_AMBULATORY_RIDE) {
    normalizedStep4.rideNotes = driverNotes || step4?.rideNotes || '';
  }

  return {
    ...(existingDraft || {}),
    step1: normalizedStep1,
    step2: step2 || {},
    step3: step3 || {},
    step4: normalizedStep4,
  };
}

export function hasQuickScheduleDraftData(draft) {
  const step1 = draft?.step1 || {};
  const riderInfo =
    (typeof step1.riderInfo === 'object' && step1.riderInfo) ||
    step1.riderDraft ||
    {};

  return Boolean(
    step1.formattedRiderName ||
      step1.riderInfo?.id ||
      step1.riderDraft?.id ||
      riderInfo.firstName ||
      riderInfo.lastName ||
      riderInfo.phoneNumber ||
      draft?.step2?.vehicleType ||
      draft?.step3?.pickupAddressDetails?.formattedAddress ||
      draft?.step3?.destinationAddress?.formattedAddress ||
      draft?.step3?.pickUpDate?.datetime ||
      draft?.step4?.costCenter ||
      draft?.step4?.rideNotes ||
      draft?.step4?.driverNotesLegA ||
      draft?.step4?.driverNotesLegB,
  );
}
